import * as cart from "./cart";

const cranky = {
  ...cart,
};

declare global {
  interface Window {
    cranky: typeof cranky;
  }
}

window.cranky = cranky;
